import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  flag: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carolina Méndez',
  role: 'Entrenadora de Vóley Formativo',
  location: 'Buenos Aires, Argentina',
  flag: '🇦🇷',
  quote: 'Compré el Megapack un domingo por la noche. El lunes entré a la cancha con la clase exacta planificada. Las alumnas lo notaron enseguida. ¡Espectacular!',
  initials: 'CM',
  color: '#1E40AF'
}, {
  name: 'Andrés Salas',
  role: 'Entrenador U17',
  location: 'Madrid, España',
  flag: '🇪🇸',
  quote: 'Las pizarras del Kit Táctico me salvaron. Explicar las rotaciones ahora es mucho más visual y los chicos no se pierden tanto. Vale cada centavo.',
  initials: 'AS',
  color: '#EA580C'
}, {
  name: 'Andrea Gómez',
  role: 'Entrenadora Mini Vóley',
  location: 'Ciudad de México, México',
  flag: '🇲🇽',
  quote: 'Pensé que era "otro PDF más", pero esto es otro nivel. Los tomos de formación base están organizados por objetivo y nivel — encuentro lo que necesito al instante.',
  initials: 'AG',
  color: '#16A34A'
}, {
  name: 'Valentina Rojas',
  role: 'Entrenadora Nivel Competitivo',
  location: 'Santiago, Chile',
  flag: '🇨🇱',
  quote: 'La Guía de Variaciones en 3 Niveles eliminó el problema del grupo heterogéneo. Ahora adapto el drill y cada jugador trabaja a su nivel. Vale 10 veces lo que cuesta.',
  initials: 'VR',
  color: '#FBBF24'
}, {
  name: 'María José Castro',
  role: 'Coordinadora Deportiva',
  location: 'Bogotá, Colombia',
  flag: '🇨🇴',
  quote: 'Los bloques de preparación física son oro puro. Trabajo con equipos U15 y por fin tengo material profesional para salto y potencia. El Script de Primera Clase me cambió la conversión.',
  initials: 'MC',
  color: '#1E40AF'
}, {
  name: 'Sofía Aguirre',
  role: 'Entrenadora Primera División',
  location: 'Lima, Perú',
  flag: '🇵🇪',
  quote: 'Lo descargué un viernes y el lunes ya estaba dando entrenamientos nuevos. Compatible con tablet, así que lo llevo a la cancha sin imprimir nada. La motivación del equipo subió muchísimo.',
  initials: 'SA',
  color: '#EA580C'
}, {
  name: 'Daniel Herrera',
  role: 'Entrenador Formativo',
  location: 'Quito, Ecuador',
  flag: '🇪🇨',
  quote: 'El Calendario Anual y las Playlists de activación me ahorran horas cada semana. Mis entrenamientos tienen ritmo profesional y los chicos lo notan. La inversión se pagó sola.',
  initials: 'DH',
  color: '#16A34A'
}, {
  name: 'Patricia Vargas',
  role: 'Entrenadora U13',
  location: 'Montevideo, Uruguay',
  flag: '🇺🇾',
  quote: 'Después de 8 años en la cancha sentía que repetía lo mismo. Los 101 Drills Pro me dieron frescura. Las jugadoras ahora se sienten desafiadas otra vez.',
  initials: 'PV',
  color: '#FBBF24'
}, {
  name: 'Isabella Romero',
  role: 'Entrenadora Escolar',
  location: 'San José, Costa Rica',
  flag: '🇨🇷',
  quote: 'Las tarjetas de Scout Individual son exactas: qué medir, cómo evaluar. Ahora trabajo con datos reales y mis jugadores ven su progreso claramente.',
  initials: 'IR',
  color: '#1E40AF'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-293">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-294"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-295">
        <div className="text-center mb-10 sm:mb-14" data-id="element-296">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-297">
            ⭐ Testimonios reales
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-298">
            Entrenadores de todo el mundo{' '}
            <span className="text-primary" data-id="element-299">hispanohablante</span> ya lo usan.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4 flex-wrap" data-id="element-300">
            <span className="text-[#FBBF24] text-base sm:text-lg" data-id="element-301">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-302">
              4.9/5 · +800 reseñas verificadas en 9+ países
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-303">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(30,64,175,0.1)] flex flex-col relative" data-id="element-304">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/10 leading-none select-none" data-id="element-305">
                "
              </span>

              <div className="flex items-center gap-2 mb-3" data-id="element-306">
                <span className="text-[#FBBF24] text-sm" data-id="element-307">⭐⭐⭐⭐⭐</span>
                <span className="text-xl" aria-hidden="true" data-id="element-308">
                  {t.flag}
                </span>
              </div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-309">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-310">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-311">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-312">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-313">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-314">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-315">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-316">
          Más de{' '}
          <span className="text-primary font-bold" data-id="element-317">15.000 entrenadores</span> en
          todo el mundo hispanohablante ya enseñan con MEGAPACK VOLEY LISTO.
        </p>
      </div>
    </section>;
}